export const STORAGE_KEY = 'icfc.a11y.v1';
export const STORAGE_VERSION = 1;

export const CONTRAST_OPTIONS = ['default', 'light', 'dark', 'high'];
export const SATURATION_OPTIONS = ['none', 'grayscale', 'high-saturation', 'invert', 'monochrome'];
export const CURSOR_SIZES = [1, 1.5, 2, 3];
export const TEXT_SIZES = [70, 85, 100, 115, 130, 150, 175, 200];

export const DEFAULT_SETTINGS = {
  version: STORAGE_VERSION,
  panelOpen: false,
  contrast: 'default',
  textSize: 100,
  textSpacing: false,
  dyslexiaFont: false,
  pauseAnimations: false,
  highlightFocus: false,
  highlightHover: false,
  cursorSize: 1,
  saturation: 'none',
  underlineLinks: false,
  readingGuide: false,
  fontWeight: false,
  readingMask: false,
  hideImages: false,
  keyboardNavigation: false,
  keyboardHelpSeen: false,
  ttsEnabled: false,
  hoverReadEnabled: true,
  panelPosition: { right: 24, bottom: 24 },
};

export const SETTING_LABELS = {
  contrast: { en: 'Contrast', np: 'कन्ट्रास्ट' },
  textSize: { en: 'Text size', np: 'पाठ आकार' },
  textSpacing: { en: 'Text spacing', np: 'पाठ दूरी' },
  dyslexiaFont: { en: 'Dyslexia-friendly font', np: 'डिस्लेक्सिया-मैत्री फन्ट' },
  pauseAnimations: { en: 'Pause animations', np: 'एनिमेसन रोक्नुहोस्' },
  highlightFocus: { en: 'Highlight focus', np: 'फोकस हाइलाइट' },
  highlightHover: { en: 'Highlight hover', np: 'होभर हाइलाइट' },
  cursorSize: { en: 'Cursor size', np: 'कर्सर आकार' },
  saturation: { en: 'Color saturation', np: 'रंग संतृप्ति' },
  underlineLinks: { en: 'Underline links', np: 'लिङ्क अन्डरलाइन' },
  readingGuide: { en: 'Reading guide', np: 'पढाइ गाइड' },
};

export function isValidSettings(value) {
  if (!value || typeof value !== 'object') return false;
  if (value.version !== STORAGE_VERSION) return false;
  if (!CONTRAST_OPTIONS.includes(value.contrast)) return false;
  if (!SATURATION_OPTIONS.includes(value.saturation)) return false;
  if (!TEXT_SIZES.includes(value.textSize)) return false;
  if (!CURSOR_SIZES.includes(value.cursorSize)) return false;
  const boolKeys = [
    'panelOpen', 'textSpacing', 'dyslexiaFont', 'pauseAnimations',
    'highlightFocus', 'highlightHover', 'underlineLinks',
    'readingGuide', 'fontWeight', 'readingMask', 'hideImages', 'keyboardNavigation', 'keyboardHelpSeen',
    'ttsEnabled', 'hoverReadEnabled',
  ];
  for (const k of boolKeys) {
    if (typeof value[k] !== 'boolean') return false;
  }
  const pos = value.panelPosition;
  if (!pos || typeof pos !== 'object') return false;
  const posKeys = Object.keys(pos);
  if (posKeys.length !== 2) return false;
  if (!posKeys.includes('right') || !posKeys.includes('bottom')) return false;
  if (typeof pos.right !== 'number' || !Number.isFinite(pos.right)) return false;
  if (typeof pos.bottom !== 'number' || !Number.isFinite(pos.bottom)) return false;
  if (pos.right < 0 || pos.right > 1000) return false;
  if (pos.bottom < 0 || pos.bottom > 1000) return false;
  return true;
}
